import React, { useEffect, useState } from 'react';
import { PanelBarGLPure, GridSelectionHLPure, DropDownBtnHLPure } from '../../pures';
import { Grid } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { normalizeDateForSorting, formatDateWithShortMonth } from '../../../utils'

const DocumentPanelBarBinnacle = (props) => {
    let {
        binnacle,
        setBinnacleSelected,
        actionOptions,
        type
    } = props

    const { t } = useTranslation()

    const cellColumnOne = (props) => {
        return (
            <td className='documentPanelBarBinnacle-cell-one'>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span className="gridHLPure-userName" style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {props.dataItem.moduleName}
                    </span>
                    <span className="gridHLPure-fieldSubtitle">
                        {formatDateWithShortMonth(props.dataItem.date)}
                    </span>
                </div>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className='documentPanelBarBinnacle-cell-two'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.nameUser}
                </span>
            </td>
        );
    };

    const cellColumnThree = (props) => {
        return (
            <td className='documentPanelBarBinnacle-cell-three'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.name}
                </span>
            </td>
        );
    };

    const [actionSelected, setActionSelected] = useState('')
    const [moduleSelected, setModuleSelected] = useState(0)
    const [userSelected, setUserSelected] = useState(0)
    const [moduleOptions, setModuleOptions] = useState([])
    const [userOptions, setUserOptions] = useState([])
    const [actionOptionsFiltered, setActionOptionsFiltered] = useState(actionOptions)

    const [dataGrid, setDataGrid] = useState(binnacle)
    const [customFilters, setCustomFilters] = useState([])
    const [filter, setFilter] = useState({ logic: 'and', filters: [] })
    const [sort, setSort] = useState([
        {
            field: 'normalizedDate',
            dir: 'desc'
        }
    ])

    const UserFilterCell = () => {
        return <div className='k-filtercell'>
            <DropDownBtnHLPure
                optionsDropDown={userOptions}
                onDropDownChange={(e) => {
                    const value = e.target.value
                    const selectedValue = value === '0' ? 0 : (isNaN(value) ? value : parseInt(value))
                    setUserSelected(selectedValue)
                }}
                optionsValue={userSelected}
                valueItem={'id'}
                nameOption={'name'}
            />
        </div>
    }


    const ModuleFilterCell = () => {
        return <div className='k-filtercell'>
            <DropDownBtnHLPure
                optionsDropDown={moduleOptions}
                onDropDownChange={(e) => setModuleSelected(parseInt(e.target.value))}
                optionsValue={moduleSelected}
                valueItem={'id'}
                nameOption={'name'}
            />
        </div>
    }

    const EventFilterCell = () => {
        return <div className="k-filtercell">
            <DropDownBtnHLPure
                optionsDropDown={actionOptionsFiltered}
                onDropDownChange={(e) => {
                    const newValue = e.target.value
                    setActionSelected(newValue)
                }}
                optionsValue={actionSelected}
                valueItem={"id"}
                nameOption={"name"}
                maxCharacters={18}
                maxCharactersMenu={20}
                title={actionOptionsFiltered.find(a => a.id === actionSelected)?.name || ''}
            />
        </div>
    }

    const heightGrid = 'var(--binnacleHeight)'

    useEffect(() => {
        if (!binnacle || binnacle.length === 0) {
            setUserOptions([{ id: 0, name: t('documentPanelBarBinnacle.allUsers') }])
            setModuleOptions([{ id: 0, name: t('documentPanelBarBinnacle.allModules') }])
            return
        }

        // Filter data based on active filters

        let filteredData = [...binnacle]

        // Apply module filter if active

        if (moduleSelected !== 0) {
            filteredData = filteredData.filter(item => item.moduleId === moduleSelected)
        }

        // Apply user filter if active
        if (userSelected !== 0) {
            filteredData = filteredData.filter(item => item.userId === userSelected)
        }

        // Apply action filter if active
        if (actionSelected !== '' && actionSelected !== 0) {
            filteredData = filteredData.filter(item => item.name === actionSelected)
        }

        const extractUniqueUsers = (data) => {
            const uniqueUsers = new Map()
            data.forEach(item => {
                if (item.nameUser) {
                    // Use nameUser as a unique key to avoid duplicates
                    // If this user already exists, keep the one with a defined userId
                    if (!uniqueUsers.has(item.nameUser)) {
                        uniqueUsers.set(item.nameUser, {
                            id: item.userId || item.nameUser,
                            name: item.nameUser
                        })
                    } else {
                        // If it already exists but the new one has userId and the previous one does not, update
                        const existing = uniqueUsers.get(item.nameUser)
                        if (item.userId && !existing.id) {
                            uniqueUsers.set(item.nameUser, {
                                id: item.userId,
                                name: item.nameUser
                            })
                        }
                    }
                }
            })

            return [
                { id: 0, name: t('documentPanelBarBinnacle.allUsers') },
                ...Array.from(uniqueUsers.values())
            ]
        }

        const extractUniqueModules = (data) => {
            const uniqueModules = new Map()
            data.forEach(item => {
                if (item.moduleId && item.moduleName) {
                    uniqueModules.set(item.moduleId, {
                        id: item.moduleId,
                        name: item.moduleName
                    })
                }
            })

            return [
                { id: 0, name: t('documentPanelBarBinnacle.allModules') },
                ...Array.from(uniqueModules.values())
            ]
        }

        const extractUniqueActions = (data) => {
            const uniqueActions = new Map()
            data.forEach(item => {
                if (item.name) {
                    if (!uniqueActions.has(item.name)) {
                        uniqueActions.set(item.name, {
                            id: item.name,
                            name: item.name
                        })
                    }
                }
            })

            const result = [
                { id: '', name: t('documentPanelBarBinnacle.allActions') },
                ...Array.from(uniqueActions.values())
            ]
            return result
        }

        // Update user options based on selected module and action
        let dataForUsers = [...binnacle]
        if (moduleSelected !== 0) {
            dataForUsers = dataForUsers.filter(item => item.moduleId === moduleSelected)
        }
        if (actionSelected !== '' && actionSelected !== 0) {
            dataForUsers = dataForUsers.filter(item => item.name === actionSelected)
        }
        const newUserOptions = extractUniqueUsers(dataForUsers)
        setUserOptions(newUserOptions)

        // Update module options based on selected user and action
        let dataForModules = [...binnacle]
        if (userSelected !== 0) {
            dataForModules = dataForModules.filter(item => {
                // Compare by userId if number, or by nameUser if string
                if (typeof userSelected === 'string') {
                    return item.nameUser === userSelected
                } else {
                    return item.userId === userSelected
                }
            })
        }
        if (actionSelected !== '' && actionSelected !== 0) {
            dataForModules = dataForModules.filter(item => item.name === actionSelected)
        }
        setModuleOptions(extractUniqueModules(dataForModules))

        // Update action options based on selected module and user
        let dataForActions = [...binnacle]
        if (moduleSelected !== 0) {
            dataForActions = dataForActions.filter(item => item.moduleId === moduleSelected)
        }
        if (userSelected !== 0) {
            dataForActions = dataForActions.filter(item => {
                if (typeof userSelected === 'string') {
                    return item.nameUser === userSelected
                } else {
                    return item.userId === userSelected
                }
            })
        }

        const newActionOptions = extractUniqueActions(dataForActions)
        setActionOptionsFiltered(newActionOptions)

    }, [binnacle, moduleSelected, userSelected, actionSelected, t])

    const onFilterChange = (e) => {
        return
    }

    useEffect(() => {
        let filters = []

        if (actionSelected !== '' && actionSelected !== 0) {
            filters.push({
                field: "name",
                operator: "eq",
                value: actionSelected,
            })
        }

        if (userSelected !== 0) {
            if (typeof userSelected === 'string') {
                filters.push({
                    field: 'nameUser',
                    operator: 'eq',
                    value: userSelected,
                })
            } else {
                filters.push({
                    field: 'userId',
                    operator: 'eq',
                    value: parseInt(userSelected)
                })
            }
        }

        if (moduleSelected !== 0) {
            filters.push({
                field: 'moduleId',
                operator: 'eq',
                value: parseInt(moduleSelected)
            })
        }

        setCustomFilters(filters)
    }, [actionSelected, userSelected, moduleSelected]);

    useEffect(() => {
        if (!binnacle || binnacle.length === 0) {
            setDataGrid([])
            return
        }

        // Normalize dates for consistent sorting
        const normalizedBinnacle = binnacle.map(item => ({
            ...item,
            normalizedDate: normalizeDateForSorting(item.date),
            documentActionId: item.documentActionId ? parseInt(item.documentActionId) : item.documentActionId,
            userId: item.userId ? parseInt(item.userId) : item.userId,
            moduleId: item.moduleId ? parseInt(item.moduleId) : item.moduleId
        }))

        let completeFilter = {
            logic: "and",
            filters: customFilters,
        }

        const filteredData = customFilters.length > 0
            ? filterBy(normalizedBinnacle, completeFilter)
            : normalizedBinnacle

        setDataGrid(orderBy(filteredData, sort))
    }, [customFilters, sort, binnacle])

    const handleSortDate = (e) => {
        setSort(e.sort);
    }

    return (
        <div className='documentPanelBarBinnacle-container'>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t("documentPanelBarBinnacle.binnacle")}
                className='documentPanelBarBinnacle'
                id='documentPanelBarBinnacle'
            >
                <Grid item className={`documentPanelBarBinnacle-grid-documents ${type === process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE ? 'documentPanelBarBinnacle-file-height' : ''}`}>
                    <GridSelectionHLPure
                        styleGeneral={true}
                        styleGeneralClass={"documentPanelBarBinnacle-general-grid"}
                        pageable={false}
                        skip={0}
                        take={dataGrid.length}
                        dataGrid={dataGrid}
                        sortable={true}
                        sort={sort}
                        onSortChange={(e) => handleSortDate(e)}
                        onSelectedItem={setBinnacleSelected}
                        columnTwo={true}
                        columnThree={true}
                        columnFive={false}
                        titleRow1={t("documentPanelBarBinnacle.date")}
                        titleRow2={t("documentPanelBarBinnacle.user")}
                        titleRow3={t("documentPanelBarBinnacle.actions")}
                        cellColumnOne={cellColumnOne}
                        cellColumnTwo={cellColumnTwo}
                        cellColumnThree={cellColumnThree}
                        styleGrid={{ height: heightGrid }}
                        filterable={true}
                        filter={filter}
                        onFilterChange={onFilterChange}
                        isCheckedColOne={'normalizedDate'}
                        fieldColumn2={'nameUser'}
                        fieldColumn3={'name'}
                        filterableColumn1={true}
                        filterableColumn2={true}
                        filterableColumn3={true}
                        filterCellColumn1={ModuleFilterCell}
                        filterCellColumn2={UserFilterCell}
                        filterCellColumn3={EventFilterCell}
                        headerColumnThreeClass={"documentPanelBarBinnacle-header-cell-three"}
                        headerColumnTwoClass={"documentPanelBarBinnacle-header-cell-two"}
                        headerColumnOneClass={"documentPanelBarBinnacle-header-cell-one"}

                    />
                </Grid>
            </PanelBarGLPure>
        </div>
    )
}

export default DocumentPanelBarBinnacle